export const ADD_CREDIT_CARD = 'ADD_CREDIT_CARD'
export const ADD_CREDIT_CARD_RESET = 'ADD_CREDIT_CARD_RESET'
export const ADD_CREDIT_CARD_FAILURE = 'ADD_CREDIT_CARD_FAILURE'
